module.exports = __webpack_public_path__ + "img/education-and-training-icon.fb941671.svg";